import { IconType } from "@/components/Core/AppIcon";

export const CURRENCY_ICON: Record<string, IconType> = {
  BTC: "btc",
  ETH: "eth",
  USDT: "usdt",
  USDC: "usdc",
  LTC: "ltc",
  XRP: "xrp",
  USD: "dollar-fill",
  EUR: "dollar-fill",
};
